import React, { Component } from 'react';
import styled from 'styled-components';

const IconSVG = styled.svg`
  width: ${props => props.width ? props.width : "160px"};
  margin: ${props => props.margin ? props.margin : '0'};

  & > path {
    fill: ${props => props.fill ? props.fill : props.theme['color_purple']};
    opacity: ${props => props.opacity ? props.opacity : 1};
  }
`;

export default class MoneyIcon extends Component {
  render() {
    return (
      <IconSVG {...this.props} viewBox="0 0 500 500">
        <rect x="50" y="150" width="400" height="200" rx="25" ry="25" fill="none" stroke="#FF7200" strokeWidth="12" />
        
        <text x="50%" y="50%" fontSize="130" fontFamily="Arial" fontWeight="bold" textAnchor="middle" fill="#FF7200" dy=".3em">
          $
        </text>
      </IconSVG>
    );
  }
}
